import { Text } from "@mantine/core";
import { modals } from "@mantine/modals";
import i18n from "src/i18n";


interface Props {
  setIsCalling: (arg: boolean) => void;
}

export const openCallTokenExpirationModal = ({ setIsCalling }: Props) => {
  return modals.openConfirmModal({
    withinPortal: true,
    zIndex: 99999,
    title: <Text fw={500}>{i18n.t("call-ending-soon-title")}</Text>,
    centered: true,
    children: (
      <Text lh={1.5} fz={14}>
        {i18n.t("call-ending-soon-message")}
      </Text>
    ),
    labels: { confirm: i18n.t("leave-call-now"), cancel: i18n.t("dismiss") },
    groupProps: { gap: "xs", mt: "lg" },
    confirmProps: { color: "red" },
    onCancel: () => {
      // Do something here...
      return;
    },
    onConfirm: () => {
      setIsCalling(false);
    },
    styles: { body: { minHeight: "auto" } },
  });
};
